module.exports = __webpack_public_path__ + "static/img/fifth1.e2c2380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fifth1.png
// module id = j6lV
// module chunks = 25